const paginateCommon = {
	pageTo: 'Go to',
	pageName: 'Page',
	sure: 'Confirm',
	total: 'Total',
	totalNum: 'items'
}
export default paginateCommon